import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { CircularProgress, Stack, Typography } from "@mui/material";

import AppLayout from "../components/layout/AppLayout";
import { useAuth } from "../contexts/AuthContext";

const Agences = lazy(() => import("../containers/Agences/Agences"));
const ConfigurationCommissions = lazy(() =>
  import("../containers/ConfigurationCommissions/ConfigurationCommissions")
);
const Contacts = lazy(() => import("../containers/Contacts/Contacts"));
const HouseForSale = lazy(() => import("../containers/HouseForSale/HouseForSale"));
const HouseToRent = lazy(() => import("../containers/HouseToRent"));
const LoginForm = lazy(() => import("../containers/LoginForm/LoginForm"));
const Salaires = lazy(() => import("../containers/Salaires/Salaires"));
const Users = lazy(() => import("../containers/Users/Users"));
const VenteImportXls = lazy(() => import("../containers/VenteImportXls/VenteImportXls"));
const VenteListe = lazy(() => import("../containers/VenteListe/VenteListe"));

function RouteLoader() {
  return (
    <Stack alignItems="center" justifyContent="center" spacing={2} sx={{ minHeight: "100%" }}>
      <CircularProgress color="secondary" />
      <Typography color="text.secondary">Chargement du module...</Typography>
    </Stack>
  );
}

export default function AppRoutes() {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return (
      <Suspense fallback={<RouteLoader />}>
        <Routes>
          <Route path="/login" element={<LoginForm />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Suspense>
    );
  }

  return (
    <Suspense fallback={<RouteLoader />}>
      <Routes>
        <Route element={<AppLayout />}>
          <Route index element={<Navigate to="/contacts" replace />} />
          <Route path="/contacts" element={<Contacts />} />
          <Route path="/houseforsale" element={<HouseForSale />} />
          <Route path="/housetorent" element={<HouseToRent />} />
          <Route path="/sales" element={<VenteListe />} />
          <Route path="/import-xls" element={<VenteImportXls />} />
          <Route path="/salaire" element={<Salaires />} />
          <Route path="/configuration/users" element={<Users />} />
          <Route
            path="/configuration/commissions"
            element={<ConfigurationCommissions />}
          />
          <Route path="/configuration/agences" element={<Agences />} />
        </Route>
        <Route path="*" element={<Navigate to="/contacts" replace />} />
      </Routes>
    </Suspense>
  );
}
